/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    br: "br"
  }, _provideComponents(), props.components);
  return React.createElement(_components.p, null, "This site is ", React.createElement(_components.a, {
    href: "/copyleft/"
  }, "copyleft"), " 2003 – 2020 Kara Cannon.", React.createElement(_components.br), "\n", "Visual design by ", React.createElement(_components.a, {
    href: "https://helloyellowbird.com/"
  }, "HYB"), ", avatar by ", React.createElement(_components.a, {
    href: "http://www.andrearosales.com/"
  }, "Andrea Rosales"), ".");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
